export default "__VITE_ASSET__BxcHBR2D__"